<div class="font wrapper">
  <div class="top-bar">
    <div class="content-start"></div>
    <div class="logo-div">
      <img
        src="assets/images/ecolab-logo-white-app-header.png"
        alt="EcoLab Logo"
        class="logo"
      />
    </div>
    <div class="content-end">
      <select>
        <option>English</option>
        <option>Spanish</option>
      </select>
    </div>
  </div>

  <div>
    <div class="status_request">
      <div class="bg-zinc-100">
        <div class="max-w-xl mx-auto px-4 pt-4 pb-2">
          <h1 class="font mt-0">Close Request uHHgMvhI</h1>
        </div>
      </div>
    </div>

    <form>
      <div class="mb-3 mt-3">
        <label for="email" class="form-label">Your name(Optional)</label>
        <input
          type="email"
          class="form-control"
          name="email"
          (input)="updateName($event)"
        />
      </div>
      <div class="mb-3">
        <label for="pwd" class="form-label">Reason for closing request</label>
        <select class="form-select" (change)="updateRequestResolution($event)">
          <option value="" disabled selected>Select reason</option>
          <option>Reolved by technician visit</option>
          <option>Resolved by technician on the phone</option>
          <option>Resolved by requestor</option>
          <option>Service no longer needed</option>
          <option>Other</option>
        </select>
      </div>
      <div class="w-100 footer">
        <button
          type="button"
          class="btn btn-primary sendButon mb-2"
          [disabled]="name == undefined || issueResolution == undefined"
          routerLink="/esrSummary"
        >
          Close request
        </button>
        <button
          type="button"
          class="btn btn-light cancelButton"
          routerLink="/esrSummary"
        >
          Cancel
        </button>
      </div>
    </form>
  </div>
</div>
